import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedGenericS3App from "./EmbeddedGenericS3App";
const GenericS3App = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("genericS3.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("genericS3.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedGenericS3App, null));
};
export default GenericS3App;
